import numeral from 'numeral';
export function formatEuro(n) {
	return `€ ${numeral(n).format('0,0.00')}`;
}
